import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import * as React from "react";

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant?: "danger" | "info" | "warning";
  title?: string;
  text?: string | string[];
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  text,
  onSubmit,
  onClose
}) => {
  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        { Array.isArray(text) && text.map((item, i) => {
            return <DialogContentText key={i}>{item}</DialogContentText>
          })
        }
        {
          !Array.isArray(text) && <DialogContentText>{text}</DialogContentText>
        }
      </DialogContent>
      <DialogActions>
        {variant === "danger" && (
          <>
            <Button color="primary" onClick={onSubmit}>
              OK
            </Button>
            <Button color="primary" onClick={onClose} autoFocus>
              Cancel
            </Button>
          </>
        )}

        {variant === "warning" && (
          <>
            <Button color="primary" onClick={onClose} autoFocus>
              Cancel
            </Button>
            <Button color="primary" onClick={onSubmit}>
              Confirm
            </Button>
          </>
        )}

        {variant === "info" && (
          <Button color="primary" onClick={onSubmit}>
            OK
          </Button>
        )}

      </DialogActions>
    </Dialog>
  );
};
